import { itemIsProject, LibraryItem, LibraryItemStatus, LibraryItemType } from '@d-id/types';

export const hasError = (item: LibraryItem) => item.status === LibraryItemStatus.Error;

export const isGenerating = (item: LibraryItem) => {
    if (itemIsProject(item)) {
        return [LibraryItemStatus.Started, LibraryItemStatus.Ready].includes(item.status); // projects
    }

    if (item.type === LibraryItemType.SIMPLESHOW) {
        return false;
    }

    return [LibraryItemStatus.Created, LibraryItemStatus.Started].includes(item.status); // talks and clips
};

export const isDraft = (item: LibraryItem) => item.status !== LibraryItemStatus.Done;

export const isPlayable = (item: LibraryItem) => item.status === LibraryItemStatus.Done;
